import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TableHead from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableHead';
import TableRow from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableRow';
import TableHeadItem
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/Allocations/TableView/CollapsableTable/TableHeadItem';
import TableCell from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableCell';

const styles = theme => ({
  root: {
    padding: theme.spacing(2, 0),
  },
  fillerCell: {
    backgroundColor: theme.palette.common.white,
    position: 'sticky',
    left: 0,
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    zIndex: 102,
  },
  stickyRow: {
    position: 'sticky',
    zIndex: 101,
  },
});

const TableHeader = ({
  className,
  classes,
  columns,
}) => {
  return (
    <TableHead className={classNames(classes.root, className)}>
      <TableRow className={classes.stickyRow}>
        <TableCell className={classes.fillerCell} />
        {columns.map((h) => {
          return <TableHeadItem className={classes.stickyRow} key={h.key} item={h} />;
        })}
      </TableRow>
    </TableHead>
  );
};

TableHeader.defaultProps = {
  className: '',
};

TableHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
};

export default withStyles(styles)(TableHeader);
